export default __webpack_public_path__ + "../img/880188a595be277355d6fa939e36e5bb.png";